import StationWidget from "./StationWidget";
import LoadingIcon from "../../../../components/shared/LoadingIcon";
import { checknames, checkpoints } from "../../../../utils/dummy";

export default function WallVisits({ visits, isLoading }: any) {
  const getData = () => {
    const groupedData = visits?.reduce((acc: any, item: any) => {
      const stationId = item.station.name;

      if (!acc[stationId]) {
        acc[stationId] = [];
      }
      acc[stationId].order = checkpoints[item?.station?.name];
      acc[stationId].name = checknames[item?.station?.name];
      acc[stationId].push(item);
      return acc;
    }, {});

    const stations = Object.keys(groupedData).map((stationId) => ({
      stationId,
      data: groupedData[stationId],
      order: groupedData[stationId].order,
    }));

    stations.sort((a: any, b: any) => {
      if (a.order < b.order) return -1;
      if (a.order > b.order) return 1;
      return 0;
    });

    return stations;
  };

  const data = getData();

  if (isLoading) {
    return (
      <div className="flex justify-center bg-white">
        <LoadingIcon />
      </div>
    );
  }

  return (
    <div className="p-2">
      <div className="grid grid-cols-12 gap-2 h-auto">
        {data?.map((station: any, index: number) => {
          if (station?.stationId !== "Main Gate") {
            return <StationWidget station={station} key={index} />;
          }
        })}
      </div>
    </div>
  );
}
